export default {
  color: {
    mainRed: "#F24B59",
    mainBlue: "#033E8C",
    subBlue: "#385DD9",
    creamBlue: "#99AFF2",
  },
};
